/**
 * CSV 내보내기 유틸리티
 * UTF-8 BOM을 포함하여 한글이 깨지지 않도록 처리
 */

export interface CSVColumn<T> {
  key: keyof T;
  header: string;
  formatter?: (value: any) => string;
}

export function exportToCSV<T extends Record<string, any>>(
  data: T[],
  columns: CSVColumn<T>[],
  filename: string
): void {
  // UTF-8 BOM 추가 (Excel에서 한글 정상 표시)
  const BOM = '\uFEFF';

  // 헤더 생성
  const headers = columns.map((col) => col.header).join(',');

  // 데이터 행 생성
  const rows = data
    .map((item) => {
      return columns
        .map((col) => {
          const value = item[col.key];
          const formatted = col.formatter ? col.formatter(value) : String(value ?? '');
          // CSV 이스케이프 (쉼표, 따옴표, 줄바꿈 처리)
          const escaped = formatted.replace(/"/g, '""');
          return `"${escaped}"`;
        })
        .join(',');
    })
    .join('\n');

  const csv = BOM + headers + '\n' + rows;

  // Blob 생성 및 다운로드
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
